var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logged-as-card"},[_c('div',{staticClass:"log-as-text"},[_c('p',[_vm._v("Logged as")]),_c('p',[_vm._v(_vm._s(_vm.websiteUrl))])]),_c('Logout',{staticClass:"log-out-icon",on:{"click":_vm.logOut}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }